// extracted by mini-css-extract-plugin
export default {"sponsorshipContainer":"StreamStack_sponsorshipContainer__jAKEz"};